import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { Countries } from '../../../utils/countries-enum';

export class HongkongManifest {
  da: DynamicArrayGenerator;
  constructor() {
    this.da = new DynamicArrayGenerator();
  }
  public getHKGManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'tax-fee',
        'module': 'GlobalModule'
      },
      {
        'key': 'intermediary-question',
        'module': 'GlobalModule'
      },
      {
        'key': 'deal-file-check-list',
        'module': 'GlobalModule'
      },
      {
        'key': 'company-names',
        'module': 'GlobalModule'
      },
      {
        'key': 'gst-fee-field',
        'module': 'GlobalModule'
      },
      {
        'key': 'invoice-header',
        'module': 'GlobalModule'
      },
      {
        'key': 'gws-entity-location',
        'module': 'GlobalModule'
      },
      {
        'key': 'billing-information',
        'module': 'GlobalModule'
      },
      {
        'key': 'tax-fee-percent',
        'module': 'GlobalModule'
      }
    ];
    // tslint:disable-next-line: no-use-before-declare
    return this.da.generateManifest(components, Countries.Hongkong);
  }
}
